import { Injectable } from '@angular/core';
import { Inventory } from '@wb/core/interfaces/inventory';
import { gql, Mutation, Query } from 'apollo-angular';

export interface InventoryInsertInput {
  accountUid: String;
  input: Inventory;
}

export interface InventoryUpdateInput {
  uid: String;
  input: Inventory;
}

export interface InventoryDeleteInput {
  uid: String;
}

export interface InventoryResponse {
  insertInventory: {
    code: String;
    success: Boolean;
    message: String;
    inventory: Inventory;
  };
}

export interface ResetInventoryPricingMutationResponse {
  resetInventoryPricing: {
    code: String;
    success: Boolean;
    message: String;
  };
}

export interface SearchInventoryMarketScanIdQueryResponse {
  searchMarketScanVehicleId: {
    code: string;
    success: boolean;
    message: string;
    data: number;
  };
}

export interface ResetInventoryMarketScanIdMutationResponse {
  resetMarketScanVehicleId: {
    code: string;
    success: boolean;
    message: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class InventoryInsertGQL extends Mutation<InventoryResponse> {
  document = gql(`
    mutation insertInventory(
      $accountUid: String!
      $input: ModelInventoryInsertInput
    ) {
      insertInventory(input: $input, accountUid: $accountUid) {
        code
        success
        message
        inventory {
          uid
        }
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InventoryUpdateGQL extends Mutation<InventoryResponse> {
  document = gql(`
    mutation updateInventory(
      $uid: ID!
      $input: ModelInventoryUpdateInput
    ) {
      updateInventory(uid: $uid, input: $input) {
        code
        success
        message
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InventoryUpdateListingGQL extends Mutation<InventoryResponse> {
  document = gql(`
    mutation updateInventoryListing(
      $uid: ID!
      $delisted: Boolean!
    ) {
      updateInventoryListing(uid: $uid, delisted: $delisted) {
        code
        success
        message
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InventoryDeleteGQL extends Mutation<InventoryResponse> {
  document = gql(`
    mutation deleteInventory(
      $uid: ID!
    ) {
      deleteInventory(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InventoryPriceResetGQL extends Mutation<ResetInventoryPricingMutationResponse> {
  document = gql(`
    mutation resetInventoryPricing(
      $accountUid: String!
      $userUid: String!
      $input: ModelInventoryPricingResetInput
    ) {
      resetInventoryPricing(accountUid: $accountUid, userUid: $userUid, input: $input) {
        code
        success
        message
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InventorySearchMarketScanIdGQL extends Query<SearchInventoryMarketScanIdQueryResponse> {
  document = gql(`
    query searchMarketScanVehicleId($uid: ID!) {
      searchMarketScanVehicleId(uid: $uid) {
        code
        success
        message
        data
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class InventoryResetMarketScanIdGQL extends Mutation<ResetInventoryMarketScanIdMutationResponse> {
  document = gql(`
      mutation resetMarketScanVehicleId($uid: ID!, $marketScanId: Int!) {
        resetMarketScanVehicleId(uid: $uid, marketScanId: $marketScanId) {
          code
          success
          message
        }
      }
    `);
}
